<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="false" />
    <b-row class="justify-content-md-center">
      <b-col cols="12" md="4">
        <!-- <b-row>
          <b-col cols="12">
            <img :src="proPicImg" contain height="80px" />
            <b-form-group>
              <label for="name">Photo</label>
              <b-form-file id="file-small" @change="uploadPic" size="sm"></b-form-file>
            </b-form-group>
          </b-col>
        </b-row>-->
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label for="name">Name</label>
              <b-form-input v-model="user.name" type="text" id="name" placeholder="Name"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label for="name">Country</label>
              <b-form-input v-model="user.country" type="text" id="country" placeholder="Country"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label for="name">Age</label>
              <b-form-input v-model="user.age" type="text" id="age" placeholder="Age"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label for="name">User Type</label>
              <b-form-input
                v-model="user.type"
                type="text"
                id="type"
                :disabled="true"
                placeholder="User Type"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="4">
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label for="name">Phone</label>
              <b-row>
                <b-col cols="3">
                  <b-form-input
                    v-model="user.phonePrefix"
                    type="text"
                    id="phonePrefix"
                    placeholder="Prefix"
                  ></b-form-input>
                </b-col>
                <b-col cols="9">
                  <b-form-input v-model="user.phone" type="text" id="phone" placeholder="Phone"></b-form-input>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label for="name">Gender</label>
              <b-form-input v-model="user.gender" type="text" id="gender" placeholder="Gender"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label for="name">Occupation</label>
              <b-form-input
                v-model="user.occupation"
                type="text"
                id="occupation"
                placeholder="Occupation"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="py-2 justify-content-md-center">
      <span style="color:red">{{msg}}</span>
    </b-row>
    <b-row class="justify-content-center">
      <div class="px-2">
        <b-button variant="outline-primary" size="sm" @click.prevent="updateUser">Submit</b-button>
      </div>
      <div class="px-2">
        <b-button variant="outline-danger" size="sm" @click.prevent="colseDialog">Cancel</b-button>
      </div>
    </b-row>
  </div>
</template>
<script>
export default {
  props: ["userData"],
  data() {
    return {
      appLoading: false,
      user: null,
      msg: null,
      propic: null,
      proPicImg: null,
    };
  },
  beforeMount() {
    this.user = this.userData;
  },
  methods: {
    colseDialog() {
      this.$emit("close", { status: true, update: false });
    },
    updateUser() {
      this.appLoading = true;
      this.user["id"] = this.user._id;
      axios({
        method: "POST",
        url: "/user/AdminEdit",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: this.user
      })
        .then(response => {
          this.appLoading = false;
          if (response.data.status) {
            this.$emit("close", { status: true, update: true });
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch(err => {
          this.appLoading = false;
          this.$emit("close", { status: false, update: false });
        });
    },

    uploadPic(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 5242880) {
        this.msg = "File Should be less than 5MB";
        return;
      }
      this.propic = e.target.files[0];
      var reader = new FileReader();
      reader.onload = e => {
        this.proPicImg = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },

    uploadProPic() {
      this.appLoading = true;
      var formData = null;
      formData = new FormData();
      formData.append("photo", this.propic);
      axios({
        method: "POST",
        url: "/user/photo",
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token")
        },
        data: formData
      })
        .then(response => {
          this.appLoading = false;
          this.$emit("close", { status: false, update: false });
        })
        .catch(err => {
          this.appLoading = false;
          this.$emit("close", { status: false, update: false });
        });
    }
  }
};
</script>
